const CloverReceiptDeliveryMethod = Object.freeze({
    EMAIL: 'EMAIL',
    NO_RECEIPT: 'NO_RECEIPT',
    PRINT: 'PRINT',
    SMS: 'SMS',
});

module.exports = CloverReceiptDeliveryMethod;
